<template>
    <div>
    <div id="layout-user" :class="{'mini-sidenav': miniSideBar}" :style="{ minHeight: layoutHeight + 'px' }">

        <sideNav :isMiniSideBar="miniSideBar" @toggleNav="toggleSideNav" :style="{ height: layoutHeight + 'px' }"></sideNav>

        <div class="content_page_section" :style="{ height: layoutHeight + 'px' }">
            <slot/>
        </div>

    </div>
    </div>
</template>

<script>
    import sideNav from "./sideNav"

    export default {
        name: 'layoutUser',
        components: {
            sideNav
        },
        data() {
            return {
                layoutHeight: window.innerHeight,
                layoutWidth: window.innerWidth,
                openedSideNav: false,
            }
        },
        created() {
            window.addEventListener('resize', this.handleResize)
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize)
        },
        computed: {
            miniSideBar(){
                if(this.layoutWidth < 1280){
                    return true
                }else{
                    return this.openedSideNav
                }

            }
        },
        methods: {
            handleResize() {
                this.layoutHeight = window.innerHeight;
                this.layoutWidth = window.innerWidth;

            },
            toggleSideNav(){
                this.openedSideNav = !this.openedSideNav
                console.log("toggleNav")
            }
        }
    }
</script>

<style lang="scss">
html{
    overflow: hidden!important;
}
#layout-user{
    display: flex;
    .content_page_section{
        width: 100%;
        overflow-y: scroll;
        overflow-x: hidden;
    }
}
</style>